import React, { useRef, useState, useEffect } from 'react';
import tocIcon from './Icons/toc.svg';
import toccloseIcon from './Icons/arrow_circle_left.svg';
import playIcon from './Icons/L-Action.svg';
import pauseIcon from './Icons/Pause.svg';
import unmuteIcon from './Icons/volume_up.svg';
import ccIcon  from './Icons/closed_caption.svg';
import speed  from './Icons/slow_motion_video.svg';
import fullscreenIcon  from './Icons/fullscreen.svg';



const HtmlVideoPlayer = ({ videoSrc1, isMuted,  toggleMute, captions, handleFullscreen,onVideoEnd, audioDescriptions,decreaseCount, incrementCount,completed,Toclink1,Toclink2,Toclink3 }) => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioDescriptionsEnabled, setAudioDescriptionsEnabled] = useState(false); // State to enable/disable audio descriptions
  const [isTranscriptOpen, setIsTranscriptOpen] = useState(false);
  const [showCaptions, setShowCaptions] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const audio_description = '/assets/images/audio_description.png';
  const [isToc, setIsToc] = useState(false);
  const [nextactive, setNextActive] = useState(false);
  const [showSpeedDropdown, setShowSpeedDropdown] = useState(false);
  const [currentSpeed, setCurrentSpeed] = useState(1);
  const [interactivity, setInteractivity] = useState(true);
  const [interactivity1, setInteractivity1] = useState(true);
  const [interactivity2, setInteractivity2] = useState(true);
  const [interactivity3, setInteractivity3] = useState(true);
  const [interactivity4, setInteractivity4] = useState(true);
  const [isPausedAt16, setIsPausedAt16] = useState(false);
  const checkpoints = [16, 40, 64, 78, 101]; // Define the checkpoints (in seconds)
  const muteIcon = '/assets/images/mute.png';
  const transcript = '/assets/images/transcript.png';
  const nextIcon = '/assets/images/chevron_right.png';
  const backIcon = '/assets/images/chevron_left.png';
  const Amp = '/assets/images/amp_wrong.png';
  const Amp1 = '/assets/images/amp_wrong1.png';


  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = isMuted;
    }
  }, [isMuted]);

  const handleVolumeChange = (e) => {
    videoRef.current.volume = e.target.value;
  };



  const toggleTranscript = () => {
    setIsTranscriptOpen((prevIsTranscriptOpen) => !prevIsTranscriptOpen);
  };


  const transcriptData = [
    { startTime: 0, endTime: 30, text: "Introduction" },
    { startTime: 31, endTime: 60, text: "First Topic" },
    { startTime: 61, endTime: 90, text: "Second Topic" },
    { startTime: 91, endTime: 120, text: "Conclusion" },
  ];

  function handleTranscriptClick(time) {
    if (typeof time === 'number' && isFinite(time)) {
      videoRef.current.currentTime = time; // Set the video's current time
      videoRef.current.play(); // Optional: start playback after seeking
    } else {
      console.warn("Invalid time value:", time);
    }
  }

  const handleProgressChange = (e) => {
    const newTime = (e.target.value / 100) * duration;
    videoRef.current.currentTime = newTime;
    setCurrentTime(newTime);
    if (videoRef.current.currentTime >= duration) {
      // Handle video completion (e.g., trigger some function or update state)
      onVideoEnd();  // Assuming you want to call this function when the video ends
    }
  };
  useEffect(() => {
    const video = videoRef.current;
    const handleTimeUpdate = () => {
      setCurrentTime(video.currentTime);
      if(Math.floor(video.currentTime) < 16){
        setIsPausedAt16(false);
        setInteractivity(true);
      }
      // Pausing video at 16 seconds to enable interactivity
      else if (Math.floor(video.currentTime) === 16 && !isPausedAt16) {
        video.pause();
        setIsPlaying(false);
        setInteractivity(false);
        setInteractivity1(true);
        setInteractivity2(true);
        setInteractivity3(true);
        setInteractivity4(false);
      }
      else if(Math.floor(video.currentTime) === 17){
        setIsPausedAt16(false);
        setInteractivity(true);
      }
      if(Math.floor(video.currentTime) < 39){
        setIsPausedAt16(false);
        setInteractivity1(true);
      }
      else if(Math.floor(video.currentTime) === 40 && !isPausedAt16){
        video.pause();
        setInteractivity(true);
        setInteractivity1(false);
        setInteractivity2(true);
        setInteractivity3(true);
        setInteractivity4(false);
        setIsPlaying(false);
      }
      else if(Math.floor(video.currentTime) === 41){
         setIsPausedAt16(false);
        setInteractivity1(true);
      
      }
      else if(Math.floor(video.currentTime) === 63){
        setIsPausedAt16(false);
        setInteractivity(true);
        setInteractivity2(true);
      }
      else if(Math.floor(video.currentTime) === 64 && !isPausedAt16){
        video.pause();
        setInteractivity(true);
        setInteractivity1(true);
        setInteractivity2(false);
    
        setInteractivity3(true);
        setInteractivity4(false);
        setIsPlaying(false);
      }
      else if(Math.floor(video.currentTime) === 65){
         setIsPausedAt16(false);
        setInteractivity2(true);
      
      }
      else if(Math.floor(video.currentTime) === 77){
        setIsPausedAt16(false);
        setInteractivity3(true);
        document.getElementById('wrong1Img').style.background='';
      document.getElementById('wrongImg').style.background='';
      document.getElementById('currectImg').style.background='';
      }
      else if(Math.floor(video.currentTime) === 78 && !isPausedAt16){
        video.pause();
        setInteractivity(true);
        setInteractivity1(true);
        setInteractivity2(true);
        setInteractivity3(false);
        setInteractivity4(false);
        setIsPlaying(false);
      }
      else if(Math.floor(video.currentTime) === 79){
         setIsPausedAt16(false);
        setInteractivity3(true);
        document.getElementById('wrong1Img').style.background='';
        document.getElementById('wrongImg').style.background='';
        document.getElementById('currectImg').style.background='';
      
      }
      else if(Math.floor(video.currentTime) === 100){
        setIsPausedAt16(false);
        setInteractivity4(true);
      
      }
      else if(Math.floor(video.currentTime) === 101 && !isPausedAt16){
        video.pause();
        setInteractivity(true);
        setInteractivity1(true);
        setInteractivity2(true);
        setInteractivity3(true);
        setInteractivity4(false);
        setIsPlaying(false);
        document.getElementById('radioQuiz').style.background = '';
        document.getElementById('radioQuiz1').style.background = '';
        document.getElementById('radioQuiz2').style.background = '';
      }
      else if(Math.floor(video.currentTime) === 102){
         setIsPausedAt16(false);
        setInteractivity4(true);
       
      
      }
    };
  
    if (video) {
      video.addEventListener('timeupdate', handleTimeUpdate);
    }
  
    return () => {
      if (video) video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [isPausedAt16]);

  const handlePlay = () => {
    setInteractivity(true);
    setInteractivity(true);
    videoRef.current.play();
    setIsPlaying(true);
    setIsPausedAt16(true);
  };
  const handlePlay1 = () => {
    setInteractivity1(true);
    videoRef.current.play();
    setIsPlaying(true);
    setIsPausedAt16(true);
  };
  const handlePlay2 = () => {
    setInteractivity2(true);
    videoRef.current.play();
    setIsPlaying(true);
    setIsPausedAt16(true);
  };
  const handlePlay3 = () => {
    setInteractivity3(true);
    videoRef.current.play();
    setIsPlaying(true);
    setIsPausedAt16(true);
    document.getElementById('result').style.display='none';
  };
  const handlePlay4 = () => {
    setInteractivity4(true);
    videoRef.current.play();
    setIsPlaying(true);
    setIsPausedAt16(true);
    document.getElementById('result1').style.display='none';
  };
  
  const jumpToCheckpoint = (time) => {
    videoRef.current.currentTime = time;
    setCurrentTime(time);
  };


  const updateProgress = () => {
    if (!isDragging) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  function handleSelectAmp(amp) {
    const resultElement = document.getElementById('result');
  
    if (amp === 'currect') {
      resultElement.innerHTML = `
        <p>Correct! The clamp meter is positioned correctly.</p>
        <p>Click <strong id="continueButton">Continue</strong></p>
      `;
      resultElement.style.display = '';
      document.getElementById('wrong1Img').style.background='';
      document.getElementById('wrongImg').style.background='';
      document.getElementById('currectImg').style.background='rgba(0,255,9,0.5)';
      
      // Add a click event listener for the "Continue" button
      document.getElementById('continueButton').addEventListener('click', handlePlay3);
    } else if(amp === 'wrong') {
      document.getElementById('wrong1Img').style.background='';
      document.getElementById('wrongImg').style.background='rgba(255,0,0,0.5)';
      document.getElementById('currectImg').style.background='';

      resultElement.innerHTML = `
        <p>Incorrect positioning. Ensure the jaws are fully closed around the cable.</p>
        <p>Click <strong id="retryButton">Retry</strong></p>
      `;
      resultElement.style.display = '';
  
      // Add a click event listener for the "Retry" button
      document.getElementById('retryButton').addEventListener('click', () => {
        resultElement.style.display = 'none';
      });
    }
    else{
      document.getElementById('wrong1Img').style.background='rgba(255,0,0,0.5)';
      document.getElementById('wrongImg').style.background='';
      document.getElementById('currectImg').style.background='';

      resultElement.innerHTML = `
      
        <p>Incorrect positioning. Ensure the jaws closed around only one wire.</p>
        <p>Click <strong id="retryButton">Retry</strong></p>
      `;
      resultElement.style.display = '';
  
      // Add a click event listener for the "Retry" button
      document.getElementById('retryButton').addEventListener('click', () => {
        resultElement.style.display = 'none';
      });
    }
  }
  
  let attemptCount = 0; // Track the number of attempts

  function answer(val) {
    const resultElement = document.getElementById('result1');
    if (val === 0 || val === 1) {
      attemptCount++; // Increment on incorrect attempts
      resultElement.style.display = '';
  
      if (attemptCount >= 2) {
        resultElement.innerHTML = `
        <p>Second Incorrect! Both readings are within the expected range. Click <strong id="continueButton1">Continue</strong> to proceed.</p>
      `;
      document.getElementById('continueButton1').addEventListener('click', handlePlay4);
        attemptCount = 0; // Reset the attempt count if necessary
        return;
      }
  
      document.getElementById('radioQuiz').style.background = val === 0 ? 'black' : '';
      document.getElementById('radioQuiz1').style.background = val === 1 ? 'black' : '';
      document.getElementById('radioQuiz2').style.background = '';
      resultElement.style.display = '';
      resultElement.innerHTML = `
        <p>Incorrect! Click <strong id="retryButton1">Retry </strong> to answer again.</p>
      `;
      document.getElementById('retryButton1').addEventListener('click', () => {
        resultElement.style.display = 'none';
      });
    } else {
      // Reset attempt count on correct answer
      attemptCount = 0;
      resultElement.style.display = '';
      document.getElementById('radioQuiz').style.background = '';
      document.getElementById('radioQuiz1').style.background = '';
      document.getElementById('radioQuiz2').style.background = 'black';
      resultElement.innerHTML = `
        <p>Correct! Both readings are within the expected range. Click <strong id="continueButton1">Continue</strong> to proceed.</p>
      `;
      document.getElementById('continueButton1').addEventListener('click', handlePlay4);

      
    }
  }
  const setVideoDuration = () => {
    setDuration(videoRef.current.duration);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };
  const toggleCaptions = () => {
    setShowCaptions((prev) => !prev);
  };

  const toggleSpeedDropdown = () => {
    setShowSpeedDropdown((prev) => !prev);
  };

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.addEventListener('timeupdate', updateProgress);
      video.addEventListener('loadedmetadata', setVideoDuration);
      video.addEventListener('ended', handleVideoEnd); // Add event listener for video end
      setIsPlaying(true)
      video.play();
    }
    return () => {
      if (video) {
        video.removeEventListener('timeupdate', updateProgress);
        video.removeEventListener('loadedmetadata', setVideoDuration);
        video.removeEventListener('ended', handleVideoEnd); // Clean up the event listener
      }
    };
  }, []); 

  const handlePlaybackSpeedChange = (speed) => {
    videoRef.current.playbackRate = speed;
    setCurrentSpeed(speed);
    setPlaybackSpeed(speed);
    setShowSpeedDropdown(false);
  };
  useEffect(() => {
    const video = videoRef.current;
  
    if (video) {
      const playVideo = () => {
        video.play().then(() => {
          setIsPlaying(true);
        }).catch(error => {
          console.error("Error while playing the video:", error);
        });
      };
      
     
      video.addEventListener('loadeddata', playVideo);
      video.addEventListener('timeupdate', updateProgress);
      video.addEventListener('loadedmetadata', setVideoDuration);
      video.addEventListener('ended', handleVideoEnd);
  
      return () => {
        video.removeEventListener('loadeddata', playVideo);
        video.removeEventListener('timeupdate', updateProgress);
        video.removeEventListener('loadedmetadata', setVideoDuration);
        video.removeEventListener('ended', handleVideoEnd);
      };
    }
  }, []);
  

  const togglePlayPause = () => {
    const video = videoRef.current;

    if (video.paused) {
        video.play().then(() => {
            setIsPlaying(true); // Video is now playing, so set isPlaying to true
        }).catch(error => {
            console.error("Error while playing the video:", error);
        });
    } else {
        video.pause();
        setIsPlaying(false); // Video is now paused, so set isPlaying to false
    }
};

const handleVideoEnd = () => {
  setIsPlaying(false);
  
  // Check if `audioRef` and `videoRef` exist before accessing
 
  
  setTimeout(() => {
    setNextActive(true);
  }, 2000);

  if (onVideoEnd) {
    onVideoEnd(); // Call the provided onVideoEnd function (if necessary)
  }
};

const handleAudioDescriptionsToggle = () => {
  setAudioDescriptionsEnabled((prev) => !prev); // Toggle audio descriptions
};

  const handleMouseDown = () => {
    setIsDragging(true);
    videoRef.current.pause();
    setIsPlaying(false)
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    
    // Check if the video is at or near the end
    if (videoRef.current.currentTime >= videoRef.current.duration - 0.5) {
      // Prevent the video from playing automatically if it's at the end
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <>
    <div className="overlay-header">
      <h3>Using a Clamp Meter</h3>
    </div>
    <video ref={videoRef} playsinline="" src={videoSrc1}  aria-hidden="true" preload="metadata" className="video-player" tabindex="-1" disablepictureinpicture=""></video>
<div style={{width:'20%',height:'86%', background:'rgba(255,255,255,0.8)',position:'absolute', right:'0', display:!interactivity3?'':'none'}}>
<div style={{height:'20%', marginLeft:'auto', marginRight:'auto', width:'50%',marginTop:'10%', cursor:'pointer'}} onClick={()=>handleSelectAmp('currect')}><img src={Amp} alt="Clamp Meter" id='currectImg' style={{height:'100%'}}/></div>
<div style={{height:'20%', marginLeft:'auto', marginRight:'auto', width:'50%',marginTop:'10%', cursor:'pointer'}} onClick={()=>handleSelectAmp('wrong')}><img src={Amp1} alt="Clamp Meter" id='wrongImg' style={{height:'100%'}}/></div>
<div style={{height:'20%', marginLeft:'auto', marginRight:'auto', width:'50%',marginTop:'10%', cursor:'pointer'}} onClick={()=>handleSelectAmp('wrong1')}><img src={Amp} alt="Clamp Meter" id='wrong1Img' style={{height:'100%'}}/></div>

</div>
<div id='result' style={{padding:'2%', position:'absolute', background:'white',width:'35%',textAlign:'center' ,boxShadow:'10px 10px 18px black', display:'none'}}>

</div>
<div id='result1' style={{padding:'2%', position:'absolute', background:'white',width:'35%',textAlign:'center' ,boxShadow:'10px 10px 18px black', display:'none'}}>

</div>
 <button className='ingnition' style={{display:!interactivity?'':'none'}} onClick={handlePlay}></button>
 <button className='clickwire' style={{display:!interactivity1?'':'none'}} onClick={handlePlay1}></button>
 <button className='ampsetting' style={{display:!interactivity2?'':'none'}} onClick={handlePlay2}></button>
 <button className='radioQuiz'  style={{display:!interactivity4?'':'none'}} id='radioQuiz'  onClick={()=>answer(0)}></button>
 <button className='radioQuiz1' style={{display:!interactivity4?'':'none'}}  id='radioQuiz1' onClick={()=>answer(1)}></button>
 <button className='radioQuiz2' style={{display:!interactivity4?'':'none'}}  id='radioQuiz2' onClick={()=>answer(2)}></button>
    <button
      className='toc-open-btn'
      style={{ position: 'absolute', padding: '0',display: !isToc ? 'block' : 'none' }}
      onClick={() => setIsToc(true)}
      title='TOC Menu'
      aria-label="Open Table of Contents"
    >
<img src={tocIcon} alt="Table of Contents Icon" style={{
  width: 'clamp(20px, 2vw + 1vh, 30px)',
  height: 'clamp(20px, 2vw + 1vh, 30px)',
  background: '#d50019',
  padding: 'clamp(2px, 0.3vw + 0.2vh, 10px)',
}} />    </button>
    
    <button
      className='toc-close-btn'
      title='Close TOC Menu'
      style={{ position: 'absolute', display: isToc ? 'block' : 'none', padding: '0' }}
      onClick={() => setIsToc(false)}
      aria-label="Close Table of Contents"
    >
      <img src={toccloseIcon} alt="Close Table of Contents Icon" style={{   width: 'clamp(20px, 2vw + 1vh, 30px)',
  height: 'clamp(20px, 2vw + 1vh, 30px)', background: '#d50019', padding: '0.3vw' }} />
    </button>
    
    <div className={isToc ? 'toc' : 'toc-closed'}>
      <p style={{ padding: '0.5vw', background: '#d50019', color: 'white', display: 'flex', fontSize: '1vw' }}>
        <strong>Outline</strong>
        <img src={tocIcon} style={{ marginLeft: 'auto', display: 'flex', width: '2vw', height: '2vw' }} alt="Table of Contents Icon" />
      </p>
      <p style={{ padding: '0 0.5vw', color: 'black' }}>
        <a href='#' onClick={completed.includes(1) ? Toclink1 : null} className='custom-link' style={{ color: completed.includes(1) ? '' : 'grey', background:'none', textDecoration: 'none', borderRadius: '0.5vw', padding: '0.2vw 1vw', width: '100%', display: 'block', fontSize: '1vw' }}>
          Introduction to the Clamp Meter
        </a>
        <a href='#' className='custom-link' style={{textDecoration: 'none'}}>
          Using a Clamp Meter
        </a>
        <a href='#' onClick={completed.includes(3) ? Toclink3 : null} className='custom-link' style={{ color: completed.includes(3) ? '' : 'grey', background:'none', textDecoration: 'none', borderRadius: '0.5vw', padding: '0.2vw 1vw', width: '100%', display: 'block', fontSize: '1vw' }}>
          Summary
        </a>
      </p>
    </div>
    
    {/* <audio ref={audioRef} src={nextSound}></audio> */}
    <button 
  style={{
    position: 'absolute', 
    left: '1vw', 
    zIndex: '1000', 
    fontSize: 'clamp(6px, 1vw + 1vh, 12px)',
    display: !isToc ? '' : 'none',
     /* Responsive font size */
  }} 
  className='back' 
  onClick={decreaseCount}
  aria-label="Go back"
>
  <img 
    src={backIcon} 
    alt="Back" 
    style={{
      width: 'clamp(15px, 2vw + 1vh, 20px)', /* Responsive image size */
    }} 
  /> 
  Back
</button>
    
    <button
      style={{ position: 'absolute', right: '1vw', zIndex: '1000',fontSize: 'clamp(6px, 1vw + 1vh, 12px)', background: !completed.includes(2) ? 'grey' : '', cursor: !completed.includes(2) ? 'not-allowed' : 'pointer' }}
      disabled={!completed.includes(2)}
      className='next'
      onClick={incrementCount}
    >
      <img src={nextIcon} alt="Next Icon" style={{ width: 'clamp(15px, 2vw + 1vh, 20px)', background: !completed.includes(2) ? 'grey' : '' }} />
      Next
    </button>
    <div className={`transcript-sidebar ${isTranscriptOpen ? 'open' : ''}`}>
    <div className="transcript-content">
      <h3>Transcript</h3>
     {transcriptData.map((item, index) => (
  <p
    key={index}
    onClick={() => handleTranscriptClick(item.startTime)} // Use item.startTime here
    style={{
      cursor: 'pointer',
      color: '#007bff',
      backgroundColor: currentTime >= item.startTime && currentTime <= item.endTime ? '#cce5ff' : 'transparent',
    }}
  >
    {item.text} (Start: {formatTime(item.startTime)} - End: {formatTime(item.endTime)})
  </p>
))}
    </div>
  </div>
 
    
  <div className="controls">
      <button onClick={togglePlayPause} title={isPlaying ? 'Pause Video' : 'Play Video'} className="control-button">
        <img className='btn-img' src={isPlaying ? pauseIcon : playIcon} alt={isPlaying ? 'Pause' : 'Play'} />
      </button>
      
      <span className="time-display">
        {formatTime(currentTime)}/{formatTime(duration)}
       </span>
      
     <div className="progress-bar-container" style={{ position: 'relative',width: '75%', marginLeft: '1%' }}>
        <input 
          type="range"
          min="0"
          max="100"
          style={{ width: '100%', height: '0.3vw' }}
          value={(currentTime / duration) * 100 || 0}
          onInput={handleProgressChange}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
        />
        {checkpoints.map((checkpoint, index) => (
          <div
            key={index}
            className="checkpoint"
            style={{
              position: 'absolute',
              left: `${(checkpoint / duration) * 100}%`,
              top: '0',
              width: '1%',
              height: '30%',
              borderRadius:'50%',
              backgroundColor: 'white',
              cursor: 'pointer',
              transform: 'translateX(-50%)'
            }}
            onClick={() => jumpToCheckpoint(checkpoint)}
            aria-label={`Jump to ${checkpoint}s`}
          />
        ))}
      </div>
      
      <button onClick={toggleMute} className="control-button" title={isMuted ? 'Unmute' : 'Mute'}>
        <img className='btn-img' src={isMuted ? muteIcon : unmuteIcon} alt={isMuted ? 'Mute' : 'Unmute'} />
      </button>
      
      <button onClick={handleAudioDescriptionsToggle} title='Audio Descriptions' className="control-button">
          <img className='btn-img' src={audio_description} alt="audio_description" />
  
        </button>
      <button onClick={toggleCaptions} title='Closed Captioning' className={`control-button ${showCaptions ? 'active' : ''}`}>
        <img className='btn-img' src={ccIcon} alt="Captions" />
      </button>
      
  
    
        <>
      <div className="speed-control">
      <button onClick={toggleSpeedDropdown}  title="Playback Speed"  className={`control-button ${showSpeedDropdown ? 'active' : ''}`}>
    <img src={speed} alt="Speed" className='btn-img' style={{height:'90%', width:'90%', verticalAlign:'middle'}}/>
  </button>
  
  {showSpeedDropdown && (
    <ul className="speed-dropdown">
      {[0.5, 1, 1.5, 2].map((speed) => (
        <li key={speed} onClick={() => handlePlaybackSpeedChange(speed)} style={{ display: 'flex', alignItems: 'center',cursor:'pointer' }}>
          <span style={{ marginRight: '8px', fontSize: '1.2em', color: speed === currentSpeed ? 'white' : 'transparent' }}>•</span>
          {speed}x
        </li>
      ))}
    </ul>
  )}
</div>

</>
      <button onClick={handleFullscreen} title='Full Screen' className="control-button">
        <img className='btn-img' src={fullscreenIcon} alt="Fullscreen" />
      </button>

    </div>
    
    {showCaptions && (
      <div className="captions">
        {captions.map((caption, index) => (
          currentTime >= caption.startTime && currentTime <= caption.endTime && (
            <span key={index}>{caption.text}</span>
          )
        ))}
      </div>
    )}
  </>
  
  );
};

export default HtmlVideoPlayer;
